import { transition } from '@helpers/animate';
import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import fonts from '@helpers/fonts';
import { Device, from } from '@helpers/media';
import { paragraphLarge } from '@helpers/typography';
import { rgba } from 'polished';
import styled from 'styled-components';
const Wrapper = styled.div `
  display: block;
  user-select: none;
  margin-top: 40px;

  ul {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    place-content: center;
    place-items: center;
    width: 100%;

    li {
      display: inline-block;
      opacity: 1;
      transition: opacity 0.15s ease-out;
      padding: 0 3px;

      @media ${from(Device.Tablet)} {
        padding: 0 5px;
      }

      a,
      span {
        ${paragraphLarge}
        ${fonts.montserrat.medium};
        display: flex;
        color: ${brand.black};
        background-color: ${rgba(brand.white, 0)};
        font-feature-settings: 'tnum' on;
        margin: 0;
        place-content: center;
        place-items: center;
        transition: background-color 0.15s;
        text-decoration: none;
        width: ${fluid(30, 40)};
      }

      a {
        ${transition('color')};
        cursor: pointer;
        position: relative;

        &::after {
          ${transition('opacity')};
          content: '';
          position: absolute;
          bottom: -5px;
          height: 2px;
          width: 8px;
          background-color: ${brand.black};
          opacity: 0;
        }

        &:focus {
          outline: none;
        }

        &:hover {
          color: ${brand.green.base};

          &::after {
            opacity: 1;
          }
        }

        @supports selector(:focus-visible) {
          &:focus-visible {
            color: ${brand.green.base};
          }
        }

        @supports not selector(:focus-visible) {
          &:focus {
            color: ${brand.green.base};
          }
        }
      }

      &.previous,
      &.next {
        text-indent: -100vw;

        &:focus {
          background-color: ${brand.black};
        }

        a {
          border: none;
          background-color: ${brand.black};
          color: ${brand.white};
          border-radius: 400000px;
          width: 50px;
          height: 50px;

          &::after {
            content: none;
          }

          &:focus,
          &:hover {
            background-color: ${brand.green.base};
          }
        }

        svg {
          display: block;
          height: 15px;
        }
      }

      &.previous {
        padding-right: 10px;

        @media ${from(Device.Tablet)} {
          padding-right: 25px;
        }
      }

      &.next {
        padding-left: 10px;

        @media ${from(Device.Tablet)} {
          padding-left: 25px;
        }
      }

      &.break {
        a {
          border: none;
          width: 20px;

          @media ${from(Device.TabletLarge)} {
            width: 30px;
          }
        }
      }

      &.selected {
        a {
          &::after {
            opacity: 1;
          }

          &:hover {
          }

          @supports selector(:focus-visible) {
            &:focus-visible {
              background-color: ${brand.grey.grey35};
              color: ${brand.white};
            }
          }

          @supports not selector(:focus-visible) {
            &:focus {
              background-color: ${brand.grey.grey35};
              color: ${brand.white};
            }
          }
        }
      }

      &.disabled {
        cursor: default;
        opacity: 0.5;
        pointer-events: none;
        visibility: hidden;
      }
    }
  }
`;
export default {
    Wrapper,
};
